import { render } from "./AppCounters.vue?vue&type=template&id=6467bc2d"
import script from "./AppCounters.vue?vue&type=script&lang=js"
export * from "./AppCounters.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__